import React, { useEffect, useState } from "react";
import { UserAuth } from "../Context";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { db } from "../FirebaseConfig";
import { Card } from "react-bootstrap";
import AddToFavorites from "../UserProfile/ProfileShoppingList/AddToFavorites";
import { Link, useParams } from "react-router-dom";
import ShopListMoreUserProfile from "./ShopListMoreUserProfile";

const ShopListCard3 = ({
  list,
  shoppingListData,
  setShoppingListData,
  setActiveAccordion,
  setLoading,
  type,
  index,
  ownerId,
}) => {
  const { user } = UserAuth();
  const { uid } = useParams();
  const [productDetails, setProductDetails] = useState([]);
  const isCurrentUserProfile = user?.uid === uid;
  const [invitedMe, setInvitedMe] = useState(false);
  useEffect(() => {
    const fetchProductDetails = async () => {
      if (!list?.products || list.products.length === 0) return;
      // setLoading(true);
      try {
        const limitedProducts = list.products.slice(0, 4);
        const productIds = limitedProducts
          .map((product) => product.id)
          .filter(Boolean);
        console.log("productIds s2", productIds);

        if (productIds.length === 0) return;

        const productsRef = collection(db, "products");
        const q = query(productsRef, where("id", "in", productIds));
        const querySnapshot = await getDocs(q);

        const details = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setProductDetails(details);
        // setLoading(false);
      } catch (error) {
        console.error("Error fetching product details with in query:", error);
      } finally {
        // setLoading(false);
      }
    };

    fetchProductDetails();
  }, [list]);

  useEffect(() => {
    if (isCurrentUserProfile) return;
    const memberCheck = async () => {
      try {
        const userRef = doc(db, "users", ownerId);
        const shoppingListRef = doc(userRef, "shoppingList", list?.listName);
        const membersRef = collection(shoppingListRef, "members");
        const memberDocRef = doc(membersRef, user?.uid);

        const docSnapshot = await getDoc(memberDocRef);

        if (docSnapshot.exists()) {
          console.log("User is a member of this list", list?.listName);
          setInvitedMe(true);
        } else {
          console.log("User is not a member of this list", list?.listName);
          setInvitedMe(false);
        }
      } catch (error) {
        console.error("Error checking membership:", error);
        return false;
      }
    };
    memberCheck();
  }, [list]);

  const BackgroundOnSvg = ({ children }) => (
    <div
      style={{
        width: "30px",
        height: "30px",
        borderRadius: "8px",
        backgroundColor: "#F1F4FF",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {children}
    </div>
  );
  const isSingleProduct = list?.products?.length === 1;
  return (
    <div
      className={`col-12 col-sm-6 col-md-4 col-lg-3 d-flex flex-column`}
      style={{ padding: "8px 4px" }}
      onClick={() => {
        // if (list?.products?.length > 0)
        setActiveAccordion([list?.listId]);
      }}
    >
      <style jsx>
        {`
          .shopListName:hover {
            color: var(--bs-link-hover-color);
          }
          .dropdown-toggle::after {
            display: none;
          }
        `}
      </style>
      <div
        style={{
          width: "100%",
          position: "relative",
        }}
      >
        {list?.products?.length > 0 &&
          (type === "invitedList" || !isCurrentUserProfile) && (
            <div
              style={{
                position: "absolute",
                bottom: "3px",
                right: "3px",
                zIndex: 1,
                width: "24px",
                height: "24px",
                backgroundColor: "#FFFFFF",
                borderRadius: "2px",
              }}
              className="d-flex justify-content-center align-items-center"
            >
              <AddToFavorites
                userId={user?.uid}
                list={list}
                listName={list?.name}
                listId={list?.listId}
                type={"shoppingList"}
              />
            </div>
          )}
        {type === "invitedList" && (
          <div
            style={{
              position: "absolute",
              bottom: "3px",
              left: "3px",
              zIndex: 1,
              padding: "4px 10px",
              height: "20px",
              backgroundColor: "#F4F9FF",
              borderRadius: "2px",
            }}
            className="d-flex justify-content-center align-items-center"
          >
            <div
              style={{
                fontFamily: "Inter",
                fontWeight: "400",
                fontSize: "12px",
                lineHeight: "100%",
                letterSpacing: "0%",
                textAlign: "center",
                color: "#005FDA",
              }}
            >
              By {list?.userName}
            </div>{" "}
          </div>
        )}
        <style jsx>
          {`
            .shopListName:hover {
              color: var(--bs-link-hover-color);
            }
            .dropdown-toggle::after {
              display: none;
            }
            .profileShoppingListModal .modal-dialog {
              // max-width: 58.5rem;
              max-width: 63.5rem;
            }
          `}
        </style>
        {/* Images */}
        <div
          className="d-flex p-0 w-100"
          style={{
            cursor: list?.products?.length > 0 ? "pointer" : "default",
            gap: "1px",
          }}
        >
          {/* Main Image */}
          {list?.products?.length === 0 ? (
            <div
              className="d-flex w-100"
              style={{ gap: "1px", cursor: "pointer" }}
            >
              <div
                className="d-flex flex-column align-items-center justify-content-center"
                style={{
                  height: "239px",
                  width: "62.5%",
                  backgroundColor: "#F4F4F4",
                  borderTopLeftRadius: "6px",
                  gap: "12px",
                }}
              >
                <svg
                  width="70"
                  height="70"
                  viewBox="0 0 90 90"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="2"
                    y="2"
                    width="86"
                    height="86"
                    rx="43"
                    stroke="white"
                    stroke-width="4"
                  />
                  <path
                    d="M38.9292 30.9243C38.9292 28.1127 41.465 25.8334 44.5932 25.8334C47.7212 25.8334 50.2572 28.1127 50.2572 30.9243C50.2572 32.2476 49.7791 33.4529 48.9468 34.3582C47.353 36.0922 44.9708 37.8386 44.9708 40.088V40.8464M44.9708 40.8464C46.9215 40.8238 48.8799 41.3656 50.5255 42.475L56.1668 46.2776M44.9708 40.8464C43.0362 40.8688 41.1092 41.4467 39.5028 42.5766L20.581 55.8867C17.1887 58.2728 19.0661 63.1667 23.3736 63.1667H67.6268C71.9815 63.1667 73.8292 58.184 70.3455 55.8358L64.1668 51.6707"
                    stroke="white"
                    stroke-width="4"
                    stroke-linecap="round"
                  />
                </svg>
                <div
                  style={{
                    fontFamily: "Inter",
                    fontWeight: "400",
                    fontSize: "13px",
                    lineHeight: "100%",
                    letterSpacing: "0%",
                    textAlign: "center",
                  }}
                >
                  No products yet
                </div>
              </div>
              <div
                className="d-flex flex-column"
                style={{ width: "37.5%", gap: "1px" }}
              >
                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{
                    height: "79px",
                    backgroundColor: "#F4F4F4",
                    borderTopRightRadius: "6px",
                  }}
                >
                  <svg
                    width="44"
                    height="32"
                    viewBox="0 0 44 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.0718 5.81818C17.0718 3.70946 18.9736 2 21.3198 2C23.6658 2 25.5678 3.70946 25.5678 5.81818C25.5678 6.81064 25.2092 7.71466 24.585 8.39364C23.3896 9.69412 21.603 11.0039 21.603 12.691V13.2598M21.603 13.2598C23.066 13.2428 24.5348 13.6492 25.769 14.4812L30 17.3332M21.603 13.2598C20.152 13.2766 18.7068 13.71 17.502 14.5574L3.31062 24.54C0.76644 26.3296 2.17442 30 5.40508 30H38.595C41.861 30 43.2468 26.263 40.634 24.5018L36 21.378"
                      stroke="white"
                      stroke-width="3"
                      stroke-linecap="round"
                    />
                  </svg>
                </div>
                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{
                    height: "79px",
                    backgroundColor: "#F4F4F4",
                  }}
                >
                  <svg
                    width="44"
                    height="32"
                    viewBox="0 0 44 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.0718 5.81818C17.0718 3.70946 18.9736 2 21.3198 2C23.6658 2 25.5678 3.70946 25.5678 5.81818C25.5678 6.81064 25.2092 7.71466 24.585 8.39364C23.3896 9.69412 21.603 11.0039 21.603 12.691V13.2598M21.603 13.2598C23.066 13.2428 24.5348 13.6492 25.769 14.4812L30 17.3332M21.603 13.2598C20.152 13.2766 18.7068 13.71 17.502 14.5574L3.31062 24.54C0.76644 26.3296 2.17442 30 5.40508 30H38.595C41.861 30 43.2468 26.263 40.634 24.5018L36 21.378"
                      stroke="white"
                      stroke-width="3"
                      stroke-linecap="round"
                    />
                  </svg>
                </div>
                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{
                    height: "79px",
                    backgroundColor: "#F4F4F4",
                  }}
                >
                  <svg
                    width="44"
                    height="32"
                    viewBox="0 0 44 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.0718 5.81818C17.0718 3.70946 18.9736 2 21.3198 2C23.6658 2 25.5678 3.70946 25.5678 5.81818C25.5678 6.81064 25.2092 7.71466 24.585 8.39364C23.3896 9.69412 21.603 11.0039 21.603 12.691V13.2598M21.603 13.2598C23.066 13.2428 24.5348 13.6492 25.769 14.4812L30 17.3332M21.603 13.2598C20.152 13.2766 18.7068 13.71 17.502 14.5574L3.31062 24.54C0.76644 26.3296 2.17442 30 5.40508 30H38.595C41.861 30 43.2468 26.263 40.634 24.5018L36 21.378"
                      stroke="white"
                      stroke-width="3"
                      stroke-linecap="round"
                    />
                  </svg>
                </div>
              </div>
            </div>
          ) : (
            <div
              // className="w-100"
              style={{
                position: "relative",
                height: "239px",
                width: isSingleProduct
                  ? "100%"
                  : list?.products?.length === 2
                  ? "50%"
                  : "62.5%",
              }}
            >
              <Card.Img
                // variant="top"
                // className="rounded-start"
                src={productDetails?.[0]?.imageUrl}
                // alt="No products to show"
                style={{
                  objectFit: "cover",
                  objectPosition: "top",
                  height: "100%",
                  borderTopLeftRadius: "6px",
                  borderTopRightRadius: isSingleProduct ? "6px" : "0",
                  filter: "contrast(1.1) brightness(0.95)",
                }}
              />
            </div>
          )}
          {/* Second Images */}
          {list?.products?.length > 3 ? (
            // More than 3 products: Show 3 stacked images
            <div
              className="d-flex flex-column "
              style={{ width: "37.5%", gap: "1px" }}
            >
              {/* 1st image */}
              <div>
                <Card.Img
                  variant="top"
                  src={productDetails?.[1]?.imageUrl}
                  style={{
                    objectFit: "cover",
                    objectPosition: "top",
                    height: "79px",
                    borderTopRightRadius: "6px",
                    borderBottomRightRadius: 0,
                    borderTopLeftRadius: 0,
                    borderBottomLeftRadius: 0,
                    filter: "contrast(1.1) brightness(0.95)",
                  }}
                />
              </div>
              {/* 2nd image */}
              <div>
                <Card.Img
                  variant="top"
                  src={productDetails?.[2]?.imageUrl}
                  style={{
                    objectFit: "cover",
                    objectPosition: "top",
                    height: "79px",
                    borderRadius: 0,
                    filter: "contrast(1.1) brightness(0.95)",
                  }}
                />
              </div>
              {/* 3rd image */}
              <div>
                <Card.Img
                  variant="top"
                  src={productDetails?.[3]?.imageUrl}
                  style={{
                    objectFit: "cover",
                    objectPosition: "top",
                    height: "79px",
                    filter: "contrast(1.1) brightness(0.95)",
                  }}
                />
              </div>
            </div>
          ) : list?.products?.length > 2 ? ( // Three Images
            <div
              className="d-flex flex-column "
              style={{ width: "37.5%", gap: "1px" }}
            >
              {/* 1st image */}
              <div>
                <Card.Img
                  variant="top"
                  src={productDetails?.[1]?.imageUrl}
                  style={{
                    objectFit: "cover",
                    objectPosition: "top",
                    height: "119px",
                    borderTopRightRadius: "6px",
                    borderBottomRightRadius: 0,
                    borderTopLeftRadius: 0,
                    borderBottomLeftRadius: 0,
                    filter: "contrast(1.1) brightness(0.95)",
                  }}
                />
              </div>
              {/* 2nd image */}
              <div style={{ position: "relative" }}>
                <Card.Img
                  variant="top"
                  src={productDetails?.[2]?.imageUrl}
                  style={{
                    objectFit: "cover",
                    objectPosition: "top",
                    height: "119px",
                    filter: "contrast(1.1) brightness(0.95)",
                  }}
                />
              </div>
            </div>
          ) : (
            list?.products?.length > 1 && ( // Two Images
              <div
                style={{
                  position: "relative",
                  width: "50%",
                }}
              >
                <div>
                  <Card.Img
                    variant="top"
                    // className="rounded-2"
                    src={productDetails?.[1]?.imageUrl}
                    style={{
                      objectFit: "cover",
                      width: "100%",
                      height: "239px",
                      objectPosition: "top",
                      borderTopRightRadius: "6px",
                      borderBottomRightRadius: 0,
                      borderTopLeftRadius: 0,
                      borderBottomLeftRadius: 0,
                      filter: "contrast(1.1) brightness(0.95)",
                    }}
                  />
                </div>
              </div>
            )
          )}
        </div>
      </div>
      <div
        className="d-flex justify-content-between align-items-center"
        style={{
          cursor: "pointer",
          borderRadius: "0px 0px 6px 6px",
          borderWidth: "0px 1px 1px 1px",
          borderStyle: "solid",
          borderColor: "#0000001A",
          padding: "6px 4px",
        }}
      >
        <div
          className="d-flex flex-column"
          style={{
            width:
              type === "myList"
                ? list?.products?.length > 0
                  ? "50%"
                  : "80%"
                : "76%",
            gap: "4px",
          }}
        >
          <div
            className="text-truncate"
            title={list?.name}
            style={{
              cursor: "pointer",
              fontFamily: "Inter",
              fontWeight: 500,
              fontSize: "16px",
              lineHeight: "120%",
              color: "black",
              width: "205px",
            }}
          >
            {list?.name}
          </div>
          <div
            className="text-truncate"
            style={{
              cursor: "pointer",
              fontFamily: "Inter",
              fontWeight: 400,
              fontSize: "14px",
              color: "#667085",
              width: "100%",
            }}
          >
            {list?.products?.length} item
            {list?.products?.length > 1 ? "s" : ""}
          </div>
        </div>
        <div
          className="d-flex align-items-center"
          onClick={(e) => e.stopPropagation()}
        >
          {(isCurrentUserProfile || invitedMe) && (
            <>
              <Link
                to={`/chat/${list?.listId}`}
                style={{
                  width: "28px",
                  height: "28px",
                }}
                className="d-flex align-items-center justify-content-end"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.3334 1.99668C10.3528 1.42944 9.21431 1.1048 8.00004 1.1048C4.31814 1.1048 1.33337 4.08956 1.33337 7.77146C1.33337 8.83793 1.58379 9.84586 2.02901 10.7398C2.14733 10.9773 2.18671 11.2489 2.11812 11.5052L1.72105 12.9893C1.54867 13.6335 2.13805 14.2228 2.78227 14.0505L4.2663 13.6534C4.52266 13.5848 4.79418 13.6242 5.03173 13.7425C5.92562 14.1877 6.93357 14.4381 8.00004 14.4381C11.6819 14.4381 14.6667 11.4533 14.6667 7.77146C14.6667 6.5572 14.342 5.41871 13.7748 4.43813"
                    stroke="#14191F"
                    stroke-linecap="round"
                  />
                  <path
                    d="M5.33337 7.77143H5.33937M7.99404 7.77143H8.00004M10.6607 7.77143H10.6667"
                    stroke="#14191F"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </Link>
              <ShopListMoreUserProfile
                list={list}
                shoppingListData={shoppingListData}
                setShoppingListData={setShoppingListData}
                setLoading={setLoading}
                BackgroundOnSvg={BackgroundOnSvg}
                setActiveAccordion={setActiveAccordion}
                imageWidth="28px"
                svgWidth="20px"
                ownerId={ownerId}
                showInviteButton={invitedMe}
                type={type}
                componentName={"ShopListCard"}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ShopListCard3;
